import { motion } from 'framer-motion';
import { useMemo } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { SpaceDiscriminator, useGetSpacesByIdQuery } from '@client/api';
import { PageDetailContent } from '@client/toolkit';

import { CommercialSpaceView } from './views/commercial-space.view';
import { CommonAreaView } from './views/common-area.view';
import { GenericView } from './views/generic.view';
import { ParkingSpotView } from './views/parking-spot.view';
import { ResidentialUnitView } from './views/residential-unit.view';
import { RoomView } from './views/room.view';
import { SpaceView } from './views/space.view';

export function SpaceDashboardRoute() {
  const { spaceId, discriminator } = useParams<{ buildingId: string; spaceId: string, discriminator: SpaceDiscriminator }>();

  const { currentData: currentSpace } = useGetSpacesByIdQuery({
    id: spaceId ?? '',
  }, { skip: !spaceId });

  const View = useMemo(() => {
    // access the currentData which doesn't reuse data from last passed in arguments
    switch (currentSpace?.discriminator || discriminator) {
      case 'CommercialSpace':
        return CommercialSpaceView;
      case 'ResidentialUnit':
        return ResidentialUnitView;
      case 'CommonArea':
        return CommonAreaView;
      case 'Room':
        return RoomView;
      case 'ParkingSpot':
        return ParkingSpotView;
      case 'Generic':
        return GenericView;
      default:
        return SpaceView;
    }
  }, [discriminator, currentSpace?.discriminator]);

  return (
    <>
      <PageDetailContent align="left">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            opacity: { ease: 'linear', duration: 0.2 },
            y: { ease: 'easeInOut', duration: 0.4 },
          }}
        >
          <View />
        </motion.div>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
